/* Preview only. The MP4 cannot be uploaded via image-only connector.
   Animated WebP makes the video gallery interaction testable without altering live product media. */
(()=>{'use strict';
  if(window.__vt35CentralVideoBound)return;
  window.__vt35CentralVideoBound=true;
  const main=()=>document.querySelector('.vt35-central-gallery [data-v34-gallery-main] img');
  const toggle=()=>document.querySelector('[data-vt35-video-toggle]');
  let poster='';
  let moving='';
  let active=false;
  const reset=()=>{
    active=false;moving='';poster='';
    const b=toggle();if(b){b.hidden=true;b.innerHTML='▶ <span>Afspelen</span>';b.setAttribute('aria-label','Speel gelvideo af');}
  };
  document.addEventListener('click',event=>{
    const thumb=event.target.closest('[data-v34-thumb]');
    if(thumb?.closest('.vt35-central-gallery')){
      reset();
      if(thumb.hasAttribute('data-vt35-motion-thumb')){
        poster=thumb.dataset.url||'';
        moving=thumb.dataset.motionSrc||'';
        const b=toggle();if(b){b.hidden=false;b.setAttribute('aria-label','Speel gelvideo af');}
      }
      return;
    }
    const b=event.target.closest('[data-vt35-video-toggle]');
    if(b&&moving){
      const img=main();if(!img)return;
      active=!active;img.src=active?moving:poster;img.removeAttribute('srcset');
      b.innerHTML=active?'❚❚ <span>Pauzeren</span>':'▶ <span>Afspelen</span>';
      b.setAttribute('aria-label',active?'Pauzeer gelvideo':'Speel gelvideo af');
    }
  });
  document.addEventListener('change',e=>{
    if(e.target.matches('input[name="v34-pack-choice"]'))reset();
  });
})();
